import { RootStore } from "./rootStore.js";
import { TreeStore } from "./treeStore.js";
import { FolderNode } from "../models/folderNode.js";
import { __ } from "../utils/i18n.js";
const createUnorganizedNode = (treeStore)=>new FolderNode({
        id: +treeStore.rootStore.optionStore.others.rootId,
        title: __("Unorganized"),
        icon: "home",
        count: 0,
        contentCustomOrder: 2,
        properties: {
            type: 4
        }
    }, treeStore);
function createAuxiliaryTreeStore(staticTree) {
    const treeStore = new TreeStore(RootStore.get, {
        skipInit: true
    });
    treeStore.staticTree = staticTree ?? [
        createUnorganizedNode(treeStore)
    ];
    return treeStore;
}
function cloneNodesFlat(nodes, targetStore) {
    return cloneTreeNodes(nodes, targetStore);
}
function cloneTreeNodes(nodes, targetStore, parent) {
    return nodes.map((n)=>{
        const node = new FolderNode({
            id: n.id,
            title: n.title,
            count: n.count,
            icon: n.icon,
            iconActive: n.iconActive,
            properties: {
                ...n.properties
            },
            childNodes: [],
            contentCustomOrder: n.contentCustomOrder,
            forceCustomOrder: n.forceCustomOrder,
            lastOrderBy: n.lastOrderBy,
            orderAutomatically: n.orderAutomatically,
            lastSubOrderBy: n.lastSubOrderBy,
            subOrderAutomatically: n.subOrderAutomatically,
            $visible: n.$visible,
            parent
        }, targetStore);
        node.childNodes = cloneTreeNodes(n.childNodes, targetStore, node);
        return node;
    });
}
const createAllNode = (treeStore)=>new FolderNode({
        id: TreeStore.ID_ALL,
        title: __("All files"),
        icon: "copy",
        count: treeStore.rootStore.optionStore.others.allPostCnt ?? 0
    }, treeStore);
export { createUnorganizedNode, createAuxiliaryTreeStore, cloneNodesFlat, cloneTreeNodes, createAllNode };
